import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useStore } from '@base-ui/utils/store/useStore';
import { useEventCalendarStoreContext } from "../../use-event-calendar-store-context/index.mjs";
import { schedulerEventSelectors } from "../../scheduler-selectors/index.mjs";
import { eventCalendarOccurrencePlaceholderSelectors } from "../../event-calendar-selectors/index.mjs";
import { processDate } from "../../process-date/index.mjs";
import { useAdapterContext } from "../../use-adapter-context/index.mjs";
import { isInternalDragOrResizePlaceholder } from "../../internals/utils/drag-utils.mjs";
export function useCalendarGridPlaceholderInRange(parameters) {
  const {
    start,
    end,
    occurrences,
    maxIndex
  } = parameters;
  const adapter = useAdapterContext();
  const store = useEventCalendarStoreContext();
  const rawPlaceholder = useStore(store, eventCalendarOccurrencePlaceholderSelectors.placeholderInTimeRange, start, end);
  const originalEventId = isInternalDragOrResizePlaceholder(rawPlaceholder) ? rawPlaceholder.eventId : null;
  const originalEvent = useStore(store, schedulerEventSelectors.processedEvent, originalEventId);
  return React.useMemo(() => {
    if (!rawPlaceholder) {
      return null;
    }
    const startProcessed = processDate(rawPlaceholder.start, adapter);
    const endProcessed = processDate(rawPlaceholder.end, adapter);
    const timezone = adapter.getTimezone(rawPlaceholder.start);
    const sharedProperties = {
      key: 'occurrence-placeholder',
      id: originalEventId ?? 'occurrence-placeholder',
      title: originalEvent ? originalEvent.title : '',
      displayTimezone: {
        start: startProcessed,
        end: endProcessed,
        timezone
      }
    };
    if (rawPlaceholder.type === 'creation') {
      return _extends({}, sharedProperties, {
        title: '',
        position: {
          firstIndex: 1,
          lastIndex: maxIndex
        }
      });
    }
    if (rawPlaceholder.type === 'external-drag') {
      return _extends({}, sharedProperties, {
        title: rawPlaceholder.eventData.title ?? '',
        position: {
          firstIndex: 1,
          lastIndex: maxIndex
        }
      });
    }
    const position = occurrences.find(occurrence => occurrence.key === rawPlaceholder.occurrenceKey)?.position ?? {
      firstIndex: 1,
      lastIndex: maxIndex
    };
    return _extends({}, sharedProperties, {
      position
    });
  }, [rawPlaceholder, adapter, originalEvent, originalEventId, occurrences, maxIndex]);
}